/**
 * 成功注册用户
 */
<template>
    <div class="suc-user-wrapper" ref="imageWrapper">
      <div class="user-rank">
        <img src="~@/assets/images/bghome.png" alt="">
      </div>
      <div class="list-wrapper">
        <div class="list-content">
          <div class="title">在这里，您可以</div>
          <ul class="content">
            <li
              class="item"
              v-for="(item, index) in iconData"
              :key="index"
            >
              <i class="icon" :class="item.icon"></i>
              <div>{{item.desc}}</div>
            </li>
          </ul>
          <div class="download-code">
            <div class="code">
              <qrcode :value="codeUrl" />
            </div>
            <div>长按识别二维码</div>
            <div>(下载便捷青岛APP体验更多服务)</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import Qrcode from 'vue-qrcode'

export default {
  name: 'sucUser',
  components: {
    Qrcode
  },
  data () {
    return {
      title: '您已注册成功',
      btnText: '下载便捷青岛APP',
      userNumber: '10000',
      codeUrl: '',
      invitationCode: '',
      dataURL: '',
      iconData: [
        {
          icon: 'icon_1',
          desc: '1.公交扫码乘车享八折优惠；'
        },
        {
          icon: 'icon_2',
          desc: '2.垃圾分类兑换信豆，赢取多重好礼；'
        },
        {
          icon: 'icon_3',
          desc: '3.互联网购药，省时省心，极速到达；'
        },
        {
          icon: 'icon_4',
          desc: '4.水电气暖，足不出户，一键缴纳；'
        },
        {
          icon: 'icon_5',
          desc: '5.注册获得信豆，享受消费抵扣特权。'
        },
        {
          icon: 'icon_6',
          desc: '更多功能，请您开启！'
        }
      ]
    }
  },
  created () {
    this.invitationCode = this.$route.query.p
    const reg = /^1\d{10}$/
    if (this.invitationCode && reg.test(this.invitationCode)) {
      Cookies.set('code', this.invitationCode)
    } else {
      Cookies.set('code', null)
    }
    const hostName = window.location.href.split('/appweb')[0]
    this.codeUrl = `${hostName}/appweb/register?p=${this.invitationCode}`
  },
  methods: {
    handleDownLoad () {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
    }
  }
}
</script>
<style lang='scss' scoped>
  .suc-user-wrapper {
    min-height: 100vh;
    background: #f1f1f1;
  }
  .user-rank {
    position: relative;
    img {
      width: 100%;
    }
  }
  .user-rank-text {
    position: absolute;
    top: 65px;
    left: 50%;
    transform: translateX(-50%);
    div {
      word-break: break-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      color: #fff;
      font-size: 22px;
    }
  }
  .list-wrapper {
    padding: 8px 18px 18px 18px;

  }
  .list-content {
    padding: 15px 20px;
    border-radius: 8px;
    background: #fff;
    font-size: 15px;
    .title {
      margin-bottom: 8px;
      font-size: 16px;
    }
    .item {
      display: flex;
      align-items: center;
      line-height: 2.8;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .icon {
      width: 25px;
      height: 25px;
      margin-right: 8px;
      background-size: 100%;
    }
    .icon_1 {
      background: url('~@/assets/images/gongjiao.png') no-repeat center center;
       background-size: 100%;
    }
    .icon_2 {
      background: url('~@/assets/images/laji.png') no-repeat center center;
       background-size: 100%;
    }
    .icon_3 {
      background: url('~@/assets/images/gouyao.png') no-repeat center center;
       background-size: 100%;
    }
    .icon_4 {
      background: url('~@/assets/images/jiaofei.png') no-repeat center center;
       background-size: 100%;
    }
    .icon_5 {
      background: url('~@/assets/images/xindou.png') no-repeat center center;
      background-size: 100%;
    }
    .icon_6 {
      background: url('~@/assets/images/more.png') no-repeat center center;
      background-size: 100%;
    }
    .download-code {
      .code {
        margin: 3px auto 15px;
        width: 150px;
        height: 150px;
        img {
          width: 100%;
        }
      }
      text-align: center;
      font-size: 12px;
    }
  }

</style>
